import React from 'react';

import css from './visualShield.module.scss';
import kids from './_kids.png';
import maxim from './_maxim.png';
// import halloween from './halloween.png';


export type TShieldVisualName = 'kids' | 'halloween' | 'maxim';

interface IVisualShieldProps {
    name: TShieldVisualName,
}

const defaultPath = '';

const shieldMap = new Map<TShieldVisualName, string>([
    ['kids', kids],
    ['maxim', maxim],

]);

export const VisualShield = (props: IVisualShieldProps) => {
    const { name } = props;

    const path = shieldMap.get(name) || defaultPath;

    if (!path) {
        return null;
    }

    return (
        <div
            className={css.visualShieldRootV2}
        >
            <img
                className={css.visualShieldImgV2}
                src={path}
                alt={name}
            />
        </div>
    );
};
